import { gql } from "@apollo/client";
import { G } from "@react-pdf/renderer";

export const GET_ALL_EQUIPMENT_REQUESTS_WITH_FULL_DETAIL = gql`
    query {
        allEquipmentRequests {
            id

            status
            emailsSent
            emailRecipients

            datetimeFulfilled
            datetimeCreated
            requestedBy {
                id
                firstName
                lastName
            }
            job {
                id
                name
            }

            createdBy {
                id
            }
            lastUpdatedBy {
                id
            }
            equipmentRequestItemsForEquipmentRequest {
                id
            }
        }
    }
`

export const GET_EQUIPMENT_REQUEST_BY_ID_WITH_FULL_DETAIL = gql`
    query equipmentRequest($id: Int!) {
        equipmentRequest(id: $id) {
            id

            status
            emailsSent
            emailRecipients

            datetimeFulfilled

            requestedBy {
                id
            }
            job {
                id
            }

            createdBy {
                id
            }
            lastUpdatedBy {
                id
            }
        }
    }
`

export const GET_EQUIPMENT_REQUEST_BY_ID_WITH_STATUS = gql`
    query equipmentRequest($id: Int!) {
        equipmentRequest(id: $id) {
            status
        }
    }
`

export const GET_EQUIPMENT_REQUEST_BY_ID_WITH_NOTES = gql`
    query equipmentRequest($id: Int!) {
        equipmentRequest(id: $id) {
            notes
        }
    }
`

// Equipment Requests - By Status
export const GET_EQUIPMENT_REQUESTS_BY_STATUS = gql`
    query equipmentRequestsByStatus($status: String!) {
        equipmentRequestsByStatus(status: $status) {
            id
            job {
                name
            }
            status
            requestedBy {
                firstName
                lastName
            }
            equipmentRequestItemsForEquipmentRequest {
                id
            }
        }
    }
`

// Equipment Request - Info
export const GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO = gql`
    query equipmentRequest($id: Int!) {
        equipmentRequest(id: $id) {
            truck {
                number
            }
            job {
                name
            }
            requestedBy {
                firstName
                lastName
            }
            datetimeCreated
            status
            datetimeFulfilled

        }
    }
`

// Equipment Request - Items
export const GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS = gql`
    query equipmentRequest($id: Int!) {
        equipmentRequest(id: $id) {

            equipmentRequestItemsForEquipmentRequest {
                id
                equipment {
                    sku
                    name
                    description
                }
                requestedQuantity
                sentQuantity
                note
            }
        }
    }
`

export const GET_EQUIPMENT_REQUEST_BY_ID_FOR_PROCESSING = gql`
    query equipmentRequest($id: Int!) {
        equipmentRequest(id: $id) {
            job {
                id
                name
            }
            truck {
                id
            }
            requestedBy {
                id
                firstName
                lastName
            }
            notes
            equipmentRequestItemsForEquipmentRequest {
                id
                equipment {
                    sku
                    name
                    description
                    quantity
                }
                requestedQuantity
                sentQuantity
                note
            }
        }
    }
`

export const GET_EQUIPMENT_REQUEST_BY_ID_FOR_PDF = gql`
    query equipmentRequest($id: Int!) {
        equipmentRequest(id: $id) {
            notes
            job {
                name
                street1
                street2
                city
                state
                zipcode
            }
            truck {
                number
            }
            requestedBy {
                firstName
                lastName
            }
            datetimeCreated
            equipmentRequestItemsForEquipmentRequest {
                equipment {
                    name
                    itemWeightInLbs
                    category {
                        id
                        name
                    }
                }
                sentQuantity
                requestedQuantity
            }
        }
    }
`